export default "__VITE_ASSET__6LL80LTP__"